import request from "../utils/request";

export const get = (id) => request.get(`/api/use_type/${id}`);
export const list = (data) => request.get("/api/use_type", data);
export const select = (data) => request.get("/api/use_type/select", data);
export const create = (data) => request.post("/api/use_type", data);
export const update = (id, data) => request.put(`/api/use_type/${id}`, data);
export const remove = (data) => request.del(`/api/use_type/${data}`);
export const toggle = (id) => request.put(`/api/use_type/${id}/toggle`);
